module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iY2lyY2xlIiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4jY2lyY2xlIC5jbHMtMXtmaWxsOmluaGVyaXQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5jaXJjbGU8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circle.svg
// module id = +g7B
// module chunks = 1